export default __webpack_public_path__ + "static/media/No Limits.da9e3116.mp3";